import { HStack, IconButton } from '@chakra-ui/react';
import { ArrowLeftIcon, ArrowRightIcon } from '@chakra-ui/icons';

interface TablePaginationProps {
  currentPage: number;
  hasNextPage: boolean;
  isLoading: boolean;
  onPrevPage: () => void;
  onNextPage: () => void;
}

export const TablePagination = ({
  currentPage,
  hasNextPage,
  isLoading,
  onPrevPage,
  onNextPage,
}: TablePaginationProps) => {
  return (
    <HStack pt={5}>
      <IconButton
        aria-label="Previous Page"
        icon={<ArrowLeftIcon />}
        onClick={onPrevPage}
        isDisabled={currentPage <= 1 || isLoading}
      />
      <IconButton
        aria-label="Next Page"
        icon={<ArrowRightIcon />}
        onClick={onNextPage}
        isDisabled={!hasNextPage || isLoading}
      />
    </HStack>
  );
};
